/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var FileAudioIcon = createIcon("FileAudioIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "44",
    height: "59",
    viewBox: "0 0 44 59",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M2.007 58.333A2.007 2.007 0 010 56.34V6.993C0 5.893.89 5 2.006 5h22.83c.551 0 1.319.322 1.705.708l11.085 11.084c.39.391.707 1.153.707 1.717v37.827a1.997 1.997 0 01-2.007 1.997H2.007Z",
    fill: "#3894FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.007 53.333A2.007 2.007 0 015 51.34V1.993C5 .893 5.89 0 7.006 0h22.83c.551 0 1.319.322 1.705.708l11.085 11.084c.39.391.707 1.153.707 1.717v37.827a1.997 1.997 0 01-2.007 1.997H7.007Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 13.5H30V1l12.5 12.5Z",
    fill: "#CCADFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 51.34c0 1.1.891 1.993 2.007 1.993h34.32a2 2 0 002.006-1.997V13.51c0-.557-.321-1.33-.707-1.717L31.54.708C31.151.317 30.385 0 29.837 0H7.006A2.007 2.007 0 005 1.993V51.34ZM6.667 2.665a1 1 0 01.998-.998h21.548l-.039 10.491a2 2 0 002.001 2.009h10.492v36.497a1 1 0 01-1.01 1.003H7.677c-.558 0-1.01-.448-1.01-1V2.666Zm24.87.538 8.593 8.594c.393.393.258.703-.292.703h-8.01c-.539 0-.995-.446-.995-.995v-8.01c0-.54.315-.68.704-.292Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.567 21.512a1.136 1.136 0 011.284.956l.01.088.003.09V34.09a2.773 2.773 0 11-1.387-2.402l.75.434v-.867l-.001-7v-.576l-.571.081-8.182 1.169-.43.061v.434l.002 10.25v.052a2.773 2.773 0 11-1.386-2.402l.75.434v-9.954c0-.565.416-1.045.976-1.125l8.182-1.168Z",
    fill: "#8F3BF2",
    stroke: "#8F3BF2"
  }));
}, {});